<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="this.grafData1.length > 0">
        <line-chart
          :chart-data="grafValues(1)"
          :options="grafOptions(1)"
        ></line-chart>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="this.grafData2.length > 0">
        <line-chart
          :chart-data="grafValues(2)"
          :options="grafOptions(2)"
        ></line-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
//import * as Colors from "@/plugins/colors.js"
import LineChart from "./LineChart.js"

export default {
  data: function() {
    return {
      loading: false,
      grafData1: [],
      grafData2: []
    }
  },
  components: { LineChart },
  props: {
    bod: {
      type: Object,
      required: true
    },
    minYear: {
      type: Number,
      required: true
    },
    maxYear: {
      type: Number,
      required: true
    }
  },
  computed: {},
  watch: {
    bod: {
      immediate: true,
      handler: function() {
        this.show(1)
        this.show(2)
      }
    }
  },
  methods: {
    grafValues: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 1:
          ret = {
            labels: this.grafData1.map(i => i.Datum),
            datasets: [
              {
                label: "Dilat_vzd",
                type: "line",
                backgroundColor: "red",
                borderColor: "red",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData1.map(i => i.DilatVzd)
              },
              {
                label: "Dilat_stc",
                type: "line",
                backgroundColor: "blue",
                borderColor: "blue",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData1.map(i => i.DilatStc)
              },
              {
                label: "Dilat_tpl",
                type: "line",
                backgroundColor: "green",
                borderColor: "green",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData1.map(i => i.DilatTpl)
              },
              {
                label: "Mer_profil",
                type: "line",
                backgroundColor: "Teal",
                borderColor: "Teal",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData1.map(i => i.MerProfil)
              }
            ]
          }
          break
        case 2:
          ret = {
            labels: this.grafData2.map(i => i.Datum),
            datasets: [
              {
                label: "Dilat_vzd",
                type: "line",
                backgroundColor: "red",
                borderColor: "red",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData2.map(i => i.DilatVzd)
              },
              {
                label: "Dilat_vzd trend",
                type: "line",
                backgroundColor: "indianred",
                borderColor: "tomato",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData2.map(i => i.DilatVzdTrend)
              },
              {
                label: "Dilat_stc",
                type: "line",
                backgroundColor: "blue",
                borderColor: "blue",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData2.map(i => i.DilatStc)
              },
              {
                label: "Dilat_stc trend",
                type: "line",
                backgroundColor: "lightblue",
                borderColor: "lightblue",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData2.map(i => i.DilatStcTrend)
              },
              {
                label: "Dilat_tpl",
                type: "line",
                backgroundColor: "green",
                borderColor: "green",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData2.map(i => i.DilatTpl)
              },
              {
                label: "Dilat_tpl trend",
                type: "line",
                backgroundColor: "lightgreen",
                borderColor: "lightgreen",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData2.map(i => i.DilatTplTrend)
              },
              {
                label: "Mer_profil",
                type: "line",
                backgroundColor: "Teal",
                borderColor: "Teal",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData2.map(i => i.MerProfil)
              },
              {
                label: "Mer_profil trend",
                type: "line",
                backgroundColor: "Turquoise",
                borderColor: "Turquoise",
                pointRadius: "2",
                borderWidth: "2",
                pointStyle: "circle",
                fill: false,
                data: this.grafData2.map(i => i.MerProfilTrend)
              }
            ]
          }
          break
        default:
          break
      }
      return ret
    },
    grafOptions: function(aIndex) {
      console.log("grafOptions", aIndex)
      let textTitle = ""
      if (aIndex === 1) {
        textTitle = "Výsledky dlhodobého merania posuvu blokov"
      }
      if (aIndex === 2) {
        textTitle = "Zmena šírky dilatácie"
      }
      let ret = ""
      ret = {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: textTitle
        },
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                unit: "month"
              }
            }
          ],
          yAxes: [
            {
              type: "linear",
              scaleLabel: {
                display: true,
                labelString: "[mm]"
              }
            }
          ]
        }
      }
      return ret
    },
    urlFetch: function(aIndex) {
      let url = "/chart/stabskal" + aIndex
      url += "?bodID=" + this.bod.ID
      url += "&rokOd=" + this.minYear
      url += "&rokDo=" + this.maxYear
      return url
    },
    show: async function(aIndex) {
      console.log("show stabskal")
      eval(`this.grafData${aIndex} = []`)
      try {
        this.loading = true
        console.log("show stabskal 2")
        let response = await this.$axios.get(this.urlFetch(aIndex))
        console.log("show stabskal 3")
        if (response.status === 200) {
          console.log("show stabskal 4")
          let data = response.data.data
          if (data === null) {
            data = []
          }
          eval(`this.grafData${aIndex} = data`)
          console.log("show stabskal 5")
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        console.log("show stabskal 6")
        this.loading = false
      }
    }
  },
  mounted: function() {}
}
</script>
